import { registerSW } from 'virtual:pwa-register'
import { toast } from '../components/toastStore'
import i18n from '../i18n'
import { keepCheckingForNewVersions, newVersionWaiting } from './newVersion'

/**
 * Registers the service worker that precaches the app shell, so the app (and the
 * calculator) open offline, and keeps looking for a new version (newVersion.ts). A new
 * version is used at once only on the first sign-in screen; anywhere else it never reloads
 * the page on its own: a share-out typed into the calculator lives only in memory, so she
 * reloads when ready.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return
  let bar: number | undefined
  const updateServiceWorker = registerSW({
    onNeedRefresh() {
      if (newVersionWaiting(() => void updateServiceWorker(true))) return
      if (bar !== undefined) toast.dismiss(bar) // a newer version replaces the bar about the last one
      bar = toast.show({
        message: i18n.t('app.update.ready'),
        duration: 0,
        action: { label: i18n.t('app.update.reload'), onAction: () => void updateServiceWorker(true) },
      })
    },
    onOfflineReady() {
      toast.show({ message: i18n.t('app.update.offlineReady'), tone: 'success' })
    },
    onRegisteredSW(_url, registration) {
      if (registration) keepCheckingForNewVersions(registration)
    },
  })
}
